import PageSpecificFaqQuestions from "@/views/PageSpecificFaq/PageSpecificFaqQuestions.vue";
import CreatePageSpecificQuestion from "@/views/PageSpecificFaq/CreatePageSpecificQuestion.vue";
import EditPageSpecificQuestion from "@/views/PageSpecificFaq/EditPageSpecificQuestion.vue";
import PageSpecificFaqUrls from "@/views/PageSpecificFaq/PageSpecificFaqUrls.vue";
const routes = [
    {
        path: "/page-specific-faq",
        name: "PageSpecificFaqQuestions",
        component: PageSpecificFaqQuestions
    },
    {
        path: "/page-specific-faq/create",
        name: "CreatePageSpecificQuestion",
        component: CreatePageSpecificQuestion
    },
    {
        path: "/page-specific-faq/edit/:faq_uuid",
        name: "EditPageSpecificQuestion",
        component: EditPageSpecificQuestion
    },
    {
        path: "/page-specific-faq/urls",
        name: "PageSpecificFaqUrls",
        component: PageSpecificFaqUrls
    }
];
export default routes;
